<template>
  <div class="absolute top-0 z-10 w-full h-full flex items-center pt-20 pb-4 justify-center">
    
    <div class=" w-full h-full bg-gray-500 blur-lg opacity-70"></div>

    <div class=" orderPanel  absolute flex flex-col m-auto w-11/12 md:w-4/5 md:max-w-md rounded bg-slate-200">
      <div class="flex border-b border-blue-400 p-2">
        <div class="ml-auto font-bold text-xl">Balance Entries</div>
        <div v-on:click="close()" class=" ml-auto w-8 h-8 bg-slate-100 border-slate-300 rounded-full flex active:scale-75 hover:scale-105">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class=" w-7 h-7 m-auto">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
        </div>
      </div>
      
      
      <div class=" flex flex-col overflow-y-auto mt-2 w-full text-sm">
        <div v-for="(data,i) in data" :key="i" class=" w-full p-4">
          <div class="flex flex-col w-full h-full rounded bg-gray-100 p-4">
            <div class=" flex flex-row h-fit w-full">
              <div class=""> User: {{ data.username }} </div>
              <div class="  ml-auto">Type: {{ data.entry_type }}</div>  
            </div>

          <div class="mt-2 flex flex-row">
            <div class=" ">
              <div class="font-medium">Entry Amount</div>
              <div>K {{ data.entry_amount }}</div>
            </div>
            <div class="mx-auto">
              <div class=" font-medium ml-auto">Previous Amount</div>  
              <div class="  ml-auto">K {{ data.previous_amount }}</div>  
            </div>

            <div>
              <div class=" font-medium ml-auto">Current Amount</div>  
              <div class=" ml-auto">K {{ data.current_amount }}</div>  
            </div>        
                      
          </div>

          <div class=" mt-2">
              <div class=" font-medium ml-auto">Entry Details:</div>  
              <div class=" ml-auto"> {{ data.entry_details }}</div>  
            </div>

          <div class="mt-2 flex flex-row text-sm font">
            <div class=" flex flex-col">
              
              <div>
                <div>
                  <div class=" mt-2 ">Entry Date: </div>
                  <div class=" font-medium">{{ convertDate(data.created_at) }}</div> 
                </div>                 
              </div>
              
            </div>
            <div class=" flex flex-col ml-auto">
              <!-- <div class=" ">Payment Status: </div>
              <div class=" font-medium ml-auto">{{ data.payment_status }}</div>   -->

              <button v-if="data.entry_type == 'payment'" v-on:click="printButton(data)" class=" bg-yellow-200  text-gray-600 font-medium cursor-pointer shadow px-2 py-1 ml-auto"> Print Receipt</button>
              <!-- <button v-else-if="data.payment_status == 'PENDING'" v-on:click="showPayment(data.amount, data.reference_id)" class=" bg-green-200  text-gray-600 font-medium cursor-pointer shadow px-2 py-1 ml-auto"> Sync Payment</button> -->
            </div>
            
          </div>
            
          </div>         
          
        </div>

      </div>
    
    </div>

  

    <div v-if="previewCase" class=" absolute top-0 z-50  w-full h-full flex items-center justify-center">
    
    <div class=" w-full h-full bg-gray-500 blur-lg opacity-70"></div>
    <div class=" absolute flex flex-col m-auto text-xl font-bold w-10/12 md:w-96 rounded bg-white p-6">
      
      
      <img v-if="ImageData" alt="logo" class="" :src=ImageData>

        <button
                class=" mt-4 self-center bg-gray-200 border-gray-300 border font-medium text-gray-600 cursor-pointer shadow py-2 px-4 mx-auto"
                @click="showPreview(false)"
              >
                Close
        </button>
        <!-- <button
                class=" mt-4 self-center bg-gray-200 border-gray-300 border font-medium text-gray-600 cursor-pointer shadow py-2 px-4 mx-auto"
                @click="ShowPayerMsgBox(false)"
              >
                Save Image
        </button> -->

      </div>
      
    </div>

    <printBalanceEntryReciept v-if="showPrintBalanceEntryRecieptPage"></printBalanceEntryReciept>
  
  </div>
  
</template>

<script>
// @ is an alias to /src

import axios from "axios";
import PrintBalanceEntryReciept from "@/components/PrintBalanceEntryReciept.vue"

export default {
  name: 'InternetSubsOrderPage',
  components: {
    // signUpPage: SignUpPage,
    printBalanceEntryReciept: PrintBalanceEntryReciept,
  },
  data () {
       return{
        details:'',
        amount:'',
        status:'',
        order_date:'',
        data:[],
        selectedUser:null,
        selectedBalanceEntry:null,
        pageNumber: 1,
        PageSize: 100,
        previewCase: false,
        showPrintBalanceEntryRecieptPage: false,
        ImageData:null,
        BackendUrl: "https://labsapi.packymstechnology.com"
       }
      },


  methods:{
    
    close(){
      this.$parent.showUserEntries(false);
    },

    convertDate(date){
      const formatter = new Intl.DateTimeFormat('en-US', { dateStyle: 'short' });
      return formatter.format(Date.parse(date))
    },

    convertDateReturnDay(date){
      const birthday = new Date(date);
      const date1 = birthday.getDate();
      return date1
    },

    printButton(data){
      this.selectedBalanceEntry = data;
      this.ShowPrintPage(true);
    },

    ShowPrintPage(show){
      this.showPrintBalanceEntryRecieptPage = show;
    },

    showContactMsg(){
      this.$parent.setMessageBox("Contact Packyms Technology to Pay Now", "warning")
    },

    showPayment(amount, ref){
      this.$parent.showPayment(true, amount, ref);
    },
    async loadInternetSubs(){
      this.$parent.showLoading(true)
      let dev = process.env.VUE_APP_DEVELOPMENT;    
    if (dev == "true") {
      console.log("is in dev mode")
      this.BackendUrl = "";
    }
         
      try {
        let result = await axios.post(this.BackendUrl + "/user/balance_entries", {
            username: this.selectedUser,
            page_id: this.pageNumber,
            page_size: this.PageSize
          });
          if(result.status == 200){
            // alert(" Order fetched")
            this.data = result.data
            // this.close();
  
          } else {
            alert("there was an error with placing Order")
          }
      } catch (error) {
        const code = error.response.status
        
          if(code == 401){
            this.close();
            this.$parent.setMessageBox("Please LogIn Again", "warning")
            this.$parent.showLogin(true);
          } else{
            this.$parent.setMessageBox("Something went wrong, Please check your internet connection or try again later", "error")
          }
      }
     
  
          
          this.$parent.showLoading(false)
    },

  },
  created(){
    this.selectedUser = this.$parent.selectedEntriesUser;
    console.log(this.selectedUser)
    if(this.selectedUser) {
      this.loadInternetSubs()
    }
  }
  
}
</script>
<style scoped>
.orderPanel{
max-height: 85%;
}
</style>
